import { render, staticRenderFns } from "./LowSalesAuthorizationNotice.vue?vue&type=template&id=ec95a0e0&scoped=true"
import script from "./LowSalesAuthorizationNotice.vue?vue&type=script&lang=js"
export * from "./LowSalesAuthorizationNotice.vue?vue&type=script&lang=js"
import style0 from "./LowSalesAuthorizationNotice.vue?vue&type=style&index=0&id=ec95a0e0&prod&scoped=true&lang=css"
import style1 from "./LowSalesAuthorizationNotice.vue?vue&type=style&index=1&id=ec95a0e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec95a0e0",
  null
  
)

export default component.exports